module.exports = __webpack_public_path__ + "static/media/product3.b0f2c40f.png";